import TableCell from './table-cell';
import TableQuery from './table-query';

// Represents a table row
export default class TableRow {
  constructor () {
    /**
     * @type {SVGGElement}
     */
    this.rowElement = undefined;

    /**
     * @type {HTMLCanvasElement}
     */
    this.canvas = INKIVE.EditorFacade.editor.canvas;
  }

  // Create a new row from given data
  /**
   *
   * @param tableElement
   * @param {{rowIndex: number, height: number}} data
   */
  fromData (tableElement, data) {
    // Query position before creating the new row (othrwise it can misleading)
    let where = TableQuery.getRowElementAt(tableElement, data.rowIndex + 1);

    if (!where) {
      // Before the borders group which is the same as after the last row
      where = TableQuery.getTableBordersElement(tableElement);
    }

    this.rowElement = this.canvas.addSvgElementFromJson({
      element: 'g',
      attr: {
        id: this.canvas.getNextId(),
        class: `table-row index-${data.rowIndex}`,
        'data-min-content-height': data.height
      }
    });

    tableElement.insertBefore(this.rowElement, where);
  }

  // Use an existing element
  fromElement (rowElement) {
    this.rowElement = rowElement;
  }

  // Shift the entire cells in the row by delta, direction is either 'h' or 'v'
  moveCellElements (delta, direction) {
    const cellElements = TableQuery.getAllCellElementsByRow(this.rowElement);

    cellElements.forEach(cellElement => {
      const cell = new TableCell();
      cell.fromElement(cellElement);
      cell.move(delta, direction);
    });
  }

  // Set row index (used for shifing row on insertion and deletion)
  setIndex (rowIndex) {
    this.rowElement.setAttribute('class', `table-row index-${rowIndex}`);
  }

  // Adds a new cell to the specified position
  insertCell (x, y, width, height, columnIndex, mergedData = '') {
    const rowIndex = TableQuery.getRowData(this.rowElement, true, false).rowIndex;

    const cell = new TableCell();
    cell.fromData(this.rowElement,
      {
        rowIndex,
        columnIndex,
        x,
        y,
        width,
        height,
        fill: 'none',
        mergedData
      });

    return cell;
  }
}
